export class Config {
  static host = process.env.API_HOST || 'https://license.ml.dbrain.io'

  // static host =
  //   process.env.NODE_ENV === 'production'
  //     ? process.env.API_HOST || 'https://license.ml.dbrain.io'
  //     : 'http://localhost:8082'
}
